export const saveJobBoardClientNameToLocalStorage = (clientName: string): void => {
    try{        
        localStorage.setItem('jobBoardClientName', clientName);
      } catch (e) {
        console.log(e);
      }
}